var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "v-select-options", attrs: { id: _vm.name } },
    [
      _c(
        "v-x-scroll",
        {
          ref: "scroll",
          attrs: {
            count: _vm.count,
            "no-id": _vm.noId,
            name: _vm._f("id")(_vm.name, "scroll"),
          },
          on: { mounted: _vm.setPosition },
        },
        [
          _c(
            "ul",
            { staticClass: "v-select-options__list" },
            _vm._l(_vm.options, function (item, index) {
              return _c(
                "li",
                {
                  key: index,
                  staticClass: "v-select-options__item",
                  class: {
                    active: _vm.getSelected(item, index),
                    "v-select-options__item--disabled": _vm.getDisabled(
                      item,
                      index
                    ),
                  },
                  attrs: { id: _vm._f("id")(_vm.name, index) },
                  on: {
                    click: function ($event) {
                      return _vm.clickOption(item)
                    },
                  },
                },
                [
                  _vm.fn && !item.isManual
                    ? _c("select-item", { attrs: { fn: _vm.fn, option: item } })
                    : [
                        _c(
                          "v-tooltip",
                          {
                            attrs: {
                              enterable: false,
                              "between-space": 0,
                              "show-only-ellipsis": "",
                              content: item.label,
                            },
                          },
                          [
                            _vm.highLightText
                              ? _c("span", {
                                  staticClass: "v-select-options__item__text",
                                  class: {
                                    padding:
                                      _vm.isMultiple &&
                                      _vm.getSelected(item, index),
                                  },
                                  style: {
                                    maxWidth: _vm.optionMaxWidth || "auto",
                                  },
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.highLight(item.label)
                                    ),
                                  },
                                })
                              : _c(
                                  "span",
                                  {
                                    staticClass: "v-select-options__item__text",
                                    class: {
                                      padding:
                                        _vm.isMultiple &&
                                        _vm.getSelected(item, index),
                                    },
                                    style: {
                                      maxWidth: _vm.optionMaxWidth || "auto",
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(item.label))]
                                ),
                          ]
                        ),
                        _vm.isMultiple && _vm.getSelected(item, index)
                          ? _c("span", {
                              staticClass:
                                "v-select__icon--right--active v-icon-ok",
                            })
                          : _vm._e(),
                      ],
                ],
                2
              )
            }),
            0
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }